/**
 * API client per la gestione della coda di triage.
 */

import axios from 'axios';

export interface QueueItem {
  case_id: string;
  patient_name: string | null;
  patient_species: string | null;
  owner_email: string | null;
  case_title: string | null;
  specialty: string | null;
  priority: string | null;
  status: string | null;
  routing_conflict: boolean;
  vet_id: string | null;
  vet_name: string | null;
  email_count: number;
  latest_subject: string | null;
  latest_received_at: string | null;
  latest_email_id: string | null;
  summary_ai: string | null;
}

export interface AssignRequest {
  vet_id: string;
}

export interface AssignResponse {
  message: string;
  case_id: string;
  vet_id: string;
  vet_name: string;
}

const api = axios.create({
  baseURL: '/api/v1',
  headers: {
    'Content-Type': 'application/json',
  },
});

export const queueApi = {
  getUnassigned: async (): Promise<QueueItem[]> => {
    const response = await api.get<QueueItem[]>('/queue/unassigned');
    return response.data;
  },

  getConflicts: async (): Promise<QueueItem[]> => {
    const response = await api.get<QueueItem[]>('/queue/conflicts');
    return response.data;
  },

  assignCase: async (caseId: string, vetId: string): Promise<AssignResponse> => {
    const response = await api.post<AssignResponse>(`/queue/cases/${caseId}/assign`, {
      vet_id: vetId,
    } as AssignRequest);
    return response.data;
  },

  routeEmail: async (emailId: string): Promise<{ message: string; vet_id: string | null; vet_name?: string }> => {
    const response = await api.post(`/queue/emails/${emailId}/route`);
    return response.data;
  },
};
